<ul class="steps-list" data-e2e="captcha-step-items">
  @for (indication of indications; track indication; let index = $index) {
    <li class="step-item mb-1">
      <div class="step-label mr-2" [ngClass]="{ 'text-primary': selections.length >= index }">
        <span class="label">{{ indication }}</span>
      </div>
      <div class="step-img">
        @if (!!selections && !!selections[index] && !!selections[index].img) {
          <img [src]="selections[index].img" data-e2e="captcha-selected-img" />
          @if (lastSelection() === index) {
            <button type="button" class="step-img-icon icon-Pencil" (click)="deleteLastChoice()" aria-label="Modifier la sélection"></button>
          }
          @if (selections.length === index) {
            <span class="ask-next text-primary h4 p-0 m-0">?</span>
          }
        } @else {
          @if (selections.length === index) {
            <span class="ask-next text-primary h4 p-0 m-0">?</span>
          }
        }
      </div>
    </li>
  }
</ul>
